import React from "react";
import Head from "next/head";

import PropertyDocuments from "components/PropertyDocuments";

import { useFormattedMessage } from "hooks";
import { neuprop0401 } from "i18n/messages/meta";
import { getDocumentsHost } from "common/helper";

const DOCUMENT_HOST = getDocumentsHost();

const propertyDocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen",
        path: `${DOCUMENT_HOST}/docs/general/neuprop/FINEXITY_neuprop040-1_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 10/2019 - PDF - 318 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)*",
        path: `${DOCUMENT_HOST}/docs/general/neuprop/FINEXITY_neuprop040-1_Basisinformationsblatt.pdf`,
        description: "Stand 11/2019 - PDF - 123 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)*",
        path: `${DOCUMENT_HOST}/docs/general/neuprop/neuprop040-1/DE-HH-01/neuprop040-1_DE-HH-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 123 KB",
    },
];

// const loremText = 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.';

// const expandedTabsData = [
//     {
//         privateTab: false,
//         name: 'Was ist ein Special Purpose Vehicle?',
//         component: loremText,
//         subSections: null,
//     },
//     {
//         privateTab: false,
//         name: 'Wofür werder SPVs gegründet und eingesetzt?',
//         component: loremText,
//         subSections: null,
//     },
//     {
//         privateTab: false,
//         name: 'Welche Vor- und Nachteile haben SPVs?',
//         component: loremText,
//         subSections: null,
//     },
//     { Neuprop0401
//         privateTab: false,
//         name: 'Welche Aufgaben übernimmt die neuprop 040 - 1 GmbH & Co. KG?',
//         component: loremText,
//         subSections: null,
//     }
// ];

const Neuprop0401 = () => {
    const { formatMessage } = useFormattedMessage();

    return (
        <>
            <Head>
                <title>{formatMessage(neuprop0401.title)}</title>

                <meta name="description" content="neuprop 040 - 1 GmbH & Co. KG" />
            </Head>
            <div className="broad-container issuer-public-page">
                <section className="banner-section" style={{ backgroundImage: "url(/images/neupropBg.jpg)" }} />
                <section className="content-section small-container">
                    <div className="header-part">
                        <div className="logo-container shadow border-radius">
                            <img src={"/images/logo-neuprop.png"} alt="" />
                        </div>
                        <p>
                            Der Unternehmensgegenstand der Gesellschaft besteht in dem Erwerb, dem Halten und Verwalten von
                            Grundstücken (die "Immobilie(n)").
                        </p>
                    </div>
                    <div className="border-x" />
                    <div className="content-part">
                        <h2>neuprop 040 - 1 GmbH & Co. KG</h2>
                        <p>
                            Bei der Finanzierung verfolgt die neuprop 040 - 1 GmbH & Co. KG eine langfristig ausgerichtete
                            Strategie.
                        </p>
                    </div>
                    <div className="two-parts">
                        <div className="first-part">
                            <div className="pdf-part">
                                <h3>Kapitalmarktdokumentation</h3>
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={propertyDocumentsData} />
                                <span className="bottom-line text-14 d-block">
                                    *Basisinformationsblatt gemäß EU-Verordnung 1286/2014
                                </span>
                            </div>
                        </div>
                        <div className="second-part">
                            <h3>Kontakt</h3>
                            <p>
                                Bei Fragen zu den tokenisierten Schuldverschreibungen sind wir persönlich erreichbar über die
                                E-Mail-Adresse:
                                <br />
                                <a href="mailto:neuprop040-1@finexity.com">neuprop040-1@finexity.com</a>
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default Neuprop0401;
